import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Inject, Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { APP_CONFIG } from 'src/app/app.config'
import { AppConfigModel } from 'src/app/core/models'

@Injectable()
export class DataDatasourceInfoService {
  constructor(
    private readonly http: HttpClient,
    @Inject(APP_CONFIG) private readonly config: AppConfigModel,
  ) {}

  loadDatasourceInfo(): Observable<Record<string, string>> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    }

    const url = `${this.config.backend_url}vzo/datasources`

    return this.http.get<Record<string, string>>(url.toString(), httpOptions)
  }
}
